
import React from 'react';
import { Table, TableCaption } from '@/components/ui/table';
import { Transaction } from '@/types/payment';
import { useTransactionFiltering } from '@/hooks/useTransactionFiltering';
import SearchBar from './transaction/SearchBar';
import TransactionTableHead from './transaction/TransactionTableHead';
import TransactionTableRows from './transaction/TransactionTableRows';

interface TransactionTableProps {
  transactions: Transaction[];
}

const TransactionTable: React.FC<TransactionTableProps> = ({ transactions }) => {
  const {
    searchQuery,
    setSearchQuery,
    sortField,
    sortDirection,
    toggleSort,
    sortedTransactions
  } = useTransactionFiltering(transactions);

  return (
    <div className="space-y-4 w-full">
      <div className="flex items-center space-x-2">
        <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      </div>
      
      <div className="rounded-md border">
        <Table>
          <TableCaption>Transaction Database</TableCaption>
          <TransactionTableHead 
            sortField={sortField} 
            sortDirection={sortDirection} 
            toggleSort={toggleSort} 
          />
          <TransactionTableRows transactions={sortedTransactions} />
        </Table>
      </div>
    </div>
  );
};

export default TransactionTable;
